import { render } from "./StatsUserCount.vue?vue&type=template&id=2d472ac2"
import script from "./StatsUserCount.vue?vue&type=script&lang=js"
export * from "./StatsUserCount.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fae/dev/grazer/grazer-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__